// extracted by mini-css-extract-plugin
export default {"dots":"styles_dots__Vy4X5","spin":"styles_spin__JDa+w"};